<div style="border: 5px solid #92d3e1;">
  <mat-toolbar style="background-color: #92d3e1; height: 35px;">
      <div style="width: 100%; display: inline-flex; justify-content: space-between;">
          <h6 style="color: black; font-weight: 400;">Hold Time-Slot Status</h6>
          <img class="close" src="../../../../../../assets/images/wow-circled-x-icon.svg" alt="close"
              (click)="closeDialog()">
      </div>
  </mat-toolbar>
  <mat-dialog-content >
      <div class="md-dialog-content user-role-dialog-content" style="padding-top: 12px; padding-left: 18px;">
        <div><strong>Total Orders: </strong>{{details.faultOperationDetails?.totalOrders?details.faultOperationDetails.totalOrders:0}}</div>
        <div><strong>No of Successful Orders: </strong>{{details.faultOperationDetails?.successCount?details.faultOperationDetails.successCount:0}}</div>
        <div><strong>No of Failed Orders: </strong>{{details.faultOperationDetails?.failCount?details.faultOperationDetails.failCount:0}}</div>
        <div style="margin-top:15px;margin-bottom: 5px;"><strong>Failed Order Details:</strong></div>
        <div *ngFor="let info of details.faultInfos;let i = index;">
          <div [ngStyle]="{'margin-top':i!=0?'15px':'0px'}">
            <strong>{{1+i}}.</strong>&nbsp;{{info.faultMessage}}</div>
        </div>
      </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" style="margin-bottom: -4px;  padding-right: 10px;">
      <button class="cancelNo" style="margin-left: 10px;" (click)="closeDialog()">OK</button>
  </mat-dialog-actions>

</div>
